define('views/blocks/ConsumableOptionsView',['jquery', 'underscore','backbone', 'app', 
    'template!blocks/consumable-options',
    'template!blocks/consumable-option-infos',
    'views/blocks/ConsumableOptionsPopinView'
    ],
    function ($, _, Backbone, app,
              consumableOptionsTemplate,
              consumableOptionInfosTemplate,
              ConsumableOptionsPopinView
    ) {

    var ConsumableOptionsView = Backbone.View.extend({
        events: {
            'click .btn-close': 'clickClose',
            'click .consumable-options  button[type=submit]': 'submit',
            'click .consumable-badge--qty': 'changeConsumable',
            'click .btn-noconsumables': 'noConsumables',
            'click .select-basic': 'focusIn',
            'click .consumable-options__cta-ingredients, .consumable': 'openConsumableModal',
        },
        initialize: function(options){

            var view = this,
                cart = view.cart = app.getCart();

            view.options = options;

            var consumableCollection = cart.getOfferedProducts();

            view.usePreset = false;//consumableCollection.isPresetValues();

            view.consumables = consumableCollection;
            view.listenTo(consumableCollection,'change:free change:quantity',view.onChange);
            view.render();
        },
        onChange:function(consumableModel,freeQuantity){
            this.refresh();
        },
        clickClose:function(e){
        	e.preventDefault();
            this.close();
        },

        focusIn: function() {
          app.$htmlBody.scrollTop($(document).height());
        },
        openConsumableModal: function() {
            if(app.isMobile()) {
                var cart = app.getCart();
                var consumablePopinModalView = new ConsumableOptionsPopinView({
                    consumables: this.consumables,
                    max_sauce: cart.get('presetConsumables').available_nb_sauce,
                    // changeConsumable: this.changeConsumable()
                })
                app.displayModal(consumablePopinModalView)
            }
        },
        changeConsumable: function(e) {
            var view = this,
                button = $(e.currentTarget),
                parent = button.parent(),
                slug = parent.attr('data-slug'),
                consumable = view.consumables.getModelBySlug(slug),
                curQty = consumable.getQuantity(),
                addQty = button.is('.add-quantity') ? 1 : -1,
                newQty = addQty + curQty;
            view.usePreset = false;
            consumable.setQuantity(newQty);
            this.setConsumable(false);
        },
        submit:function(e){
            if(e){
                e.preventDefault();
            }
            this.setConsumable(true);
        },
        setConsumable:function(close){
            var view = this,
                consumables = view.consumables;
            //
            if(view.usePreset){
                consumables.requestPreset();
            }else {
                consumables.requestSet();
            }
            if(close)
            {
                this.close();
            }
        },
        close:function () {
            // quand on quitte la fenetre on raffraichi le checksum pour indiqué que les valeurs ont étées vues
            app.getCart().hasCheckOfferedProducts();
            this.trigger('close', this);
        },
        render:function(){
            var view = this,
                cart = app.getCart(),
                consumables = view.consumables;

            view.$el.html(consumableOptionsTemplate(
                {
                    max_sauce: cart.get('presetConsumables').available_nb_sauce,
                    consumables:consumables,
                    theme:view.options.theme
                }
            ));
            view.delegateEvents();
        },
        refresh:function(){
            // TODO
            var view = this;
            view.consumables.each(function(model){
                view.$('.consumable-'+model.id+' .consumable__option-infos').html(consumableOptionInfosTemplate({model:model}));
            })
            view.delegateEvents();
        },
        noConsumables: function(e){
            e.preventDefault();
            this.consumables.each(function(consumable, m){
                consumable.setQuantity(0);
            });
            this.setConsumable();
        }

    });

    return ConsumableOptionsView;
});

